// Product gallery: crossfades [data-gallery-slide] items, syncs [data-gallery-thumb] buttons, supports swipe and arrow keys.
class SGallery extends HTMLElement {
  #ac;
  #index = 0;
  #startX = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    if (this.#slides().length < 2) return;

    this.addEventListener('command', (event) => {
      if (event.command === '--go') this.#go(Number(event.source?.dataset.index) || 0);
      if (event.command === '--next') this.#go(this.#index + 1);
      if (event.command === '--prev') this.#go(this.#index - 1);
    }, opts);

    const stage = this.querySelector('[data-gallery-stage]') || this;
    stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      this.#startX = event.clientX;
    }, opts);
    stage.addEventListener('pointerup', (event) => {
      if (this.#startX === null) return;
      const delta = event.clientX - this.#startX;
      this.#startX = null;
      if (Math.abs(delta) < 40) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const forward = rtl ? delta > 0 : delta < 0;
      this.#go(this.#index + (forward ? 1 : -1));
    }, opts);
    stage.addEventListener('pointercancel', () => { this.#startX = null; }, opts);

    this.addEventListener('keydown', (event) => {
      if (!event.target.closest?.('[data-gallery-thumb]')) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const rtl = getComputedStyle(this).direction === 'rtl';
      const forward = (event.key === 'ArrowRight') !== rtl;
      this.#go(this.#index + (forward ? 1 : -1));
      this.#thumbs()[this.#index]?.focus();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #slides() {
    return [...this.querySelectorAll('[data-gallery-slide]')];
  }

  #thumbs() {
    return [...this.querySelectorAll('[data-gallery-thumb]')];
  }

  #go(target) {
    const slides = this.#slides();
    if (!slides.length) return;
    this.#index = (target + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === this.#index;
      slide.toggleAttribute('data-active', active);
      slide.toggleAttribute('inert', !active);
      // Pause any playing video when its slide fades out.
      if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
    });
    this.#thumbs().forEach((thumb, i) => {
      const active = i === this.#index;
      thumb.setAttribute('aria-current', String(active));
      if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }
}

customElements.define('s-gallery', SGallery);
